module.exports = __webpack_public_path__ + "static/media/workplace_wellness_hr.c6bc732c.png";